import { useCallback, useContext } from "react";
import { ApproveActiveEnrollmentProps } from "../../../@types/components/enrollmentProps.types";
import { ENROLLMENT_STATUS } from "../../../constants/enrollment/enrollmentStatus";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import { dateTimeZoneConverter } from "../../../utils/commonFunctions/date";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { ThemeContext } from "../../../contexts";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { Grid, TextField } from "@material-ui/core";

import EventIcon from "@material-ui/icons/Event";
// import CustomHelperTextComponent from "../../../../../../shared/customHelperTextComponent/CustomHelperTextComponent";

import "../../../globalStyles/memberPortalTheme.css";
import "../../../globalStyles/VEBTheme.css";

const ApproveActiveEnrollment = ({
	enrollmentDate,
	enrollmentStatus,
	effectiveDate,
	handleApproveEffectiveDateChange
}: ApproveActiveEnrollmentProps) => {
	const { theme } = useContext(ThemeContext);

	const handleDateChange = () => {
		// console.log("Handle Date Change");
	};

	return (
		<div className="approve-enrollment">
			<div
				className="theme-divider-grad-mask"
				style={{
					marginTop: "2rem",
					background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
				}}
			/>

			<div className="theme-plan-section-margin" />
			<Grid container className="theme-plan-section-margin">
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label  required">Enrollment Date</div>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								className="from-date-input date-input"
								id="from-date-input"
								inputVariant="outlined"
								label={"Enrollment Date"}
								format="MM/dd/yyyy"
								error={false}
								InputProps={{
									readOnly: true
								}}
								InputLabelProps={{
									shrink: true
								}}
								value={enrollmentDate}
								onChange={handleDateChange}
								name="enrollment_date"
								keyboardIcon={<EventIcon style={{ color: "#cccccc" }} />}
								KeyboardButtonProps={{
									"aria-label": "change date"
								}}
								style={{
									pointerEvents: "unset",
									width: "200px",
									borderRadius: 20
								}}
								helperText={""}
								disabled
							/>
						</MuiPickersUtilsProvider>
						{/* <CustomInput value={dateTimeZoneConverter(enrollmentDate)} disabled /> */}
					</div>
				</Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label  required">Effective Date</div>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								className="from-date-input date-input"
								id="from-date-input"
								inputVariant="outlined"
								label={"Effective Date"}
								placeholder={"Enter effective date"}
								format="MM/dd/yyyy"
								error={false}
								InputProps={{
									readOnly: true
								}}
								InputLabelProps={{
									shrink: true
								}}
								value={effectiveDate}
								onChange={handleApproveEffectiveDateChange}
								name="effective_date"
								// disabled={approveEnrollment?.enrollment_status === "REJECTED" ? true : false}
								keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
								KeyboardButtonProps={{
									"aria-label": "change date"
								}}
								style={{
									pointerEvents: "unset",
									width: "200px",
									borderRadius: 20
								}}
								helperText={""}
							/>
						</MuiPickersUtilsProvider>
					</div>
				</Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label  required">Status</div>
						<TextField
							className="text-field-input"
							id="text-field-input"
							name="enrollment_status"
							value={initCapitalize(enrollmentStatus)}
							variant="outlined"
							InputProps={{
								readOnly: true
							}}
							style={{
								pointerEvents: "unset",
								width: "300px",
								borderRadius: 50
							}}
						/>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default ApproveActiveEnrollment;
